import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";

const UpdateProduct = ({
    currentProductId,
    currentStoreCartItemIndex,
    productModalOpen,
    updateCurrentStoreCartItemIndex = () => {},
    updateOriginalStoreCartItemIndex = () => {},
}) => {
    const { resetForm } = useFormikContext();
    const dispatch = useDispatch();

    const refreshModalInputs = () => {
        resetForm({
            values: {},
            errors: {},
            touched: {},
        });
    };
    const [productById, setProductById] = useState(0);
    const [cartItemByIndex, setCartItemByIndex] = useState(-1);

    useEffect(() => {
        if (!productModalOpen) {
            // Returns focus to the item last viewed in store list for accessibility
            const lastFocusedProductOnPage =
                productById > 0
                    ? document.getElementById(`product-${productById}`)
                    : null;

            if (lastFocusedProductOnPage !== null && productById > 0) {
                lastFocusedProductOnPage.focus();
            }
            // Returns focus to the item last changed in summary store cart for accessibility
            const lastFocusedStoreCartItem =
                cartItemByIndex !== -1
                    ? document.getElementById(`store-cart-${cartItemByIndex}`)
                    : null;

            if (lastFocusedStoreCartItem !== null && cartItemByIndex !== -1) {
                lastFocusedStoreCartItem.focus();
            }

            // We a clean start with each product to prevent attribute data from persisting
            refreshModalInputs();
            // We also need to clear the currentStoreCartItem value so data doesn't persist if closed without
            // without submitting
            dispatch(updateCurrentStoreCartItemIndex(-1));
            dispatch(updateOriginalStoreCartItemIndex(-1));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productModalOpen, productById, cartItemByIndex]);

    useEffect(() => {
        if (productModalOpen && currentProductId !== 0) {
            setProductById(currentProductId);
        }

        if (productModalOpen && currentStoreCartItemIndex !== -1) {
            setCartItemByIndex(currentStoreCartItemIndex);
        }
    }, [productModalOpen, currentProductId, currentStoreCartItemIndex]);

    return null;
};

UpdateProduct.propTypes = {
    currentProductId: PropTypes.number.isRequired,
    currentStoreCartItemIndex: PropTypes.number.isRequired,
    productModalOpen: PropTypes.bool.isRequired,
    updateCurrentStoreCartItemIndex: PropTypes.func.isRequired,
    updateOriginalStoreCartItemIndex: PropTypes.func.isRequired,
};

export default UpdateProduct;
